export const theme = {
    colors: {
        darkBorder: 'rgba(0,0,0,0.2)',
    },
};
